import { Component, OnInit } from '@angular/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { Select, Store } from '@ngxs/store';
import { GetStates } from 'app/store/state/state.actions';
import { StateState } from 'app/store/state/state.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'state-select',
  template: `
    <mat-select [formControl]="formControl" [(value)]="selected" data-cy="state-select">
      <mat-select-trigger *ngIf="selected">{{ selected }}</mat-select-trigger>
      <mat-option *ngFor="let state of states$ | async" [value]="state.value" attr.data-cy="state-option-{{state.value}}">
        {{ state.label }}
      </mat-option>
    </mat-select>
  `
})
export class StateSelectComponent extends FieldType<FieldTypeConfig> implements OnInit {

  @Select(StateState.states) states$: Observable<{}[]>;

  selected: string;

  constructor(private store: Store) {
    super();
  }

  ngOnInit() {
    this.selected = this.formControl.value;
    this.store.dispatch(new GetStates());
  }
}
